"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebkit = void 0;
const isWebkit = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const isSafariUserAgent = Boolean(navigator.userAgent.match(/Version\/[\d.]+.*Safari/));
    const isChrome = Boolean(navigator.userAgent.match(/CriOS\//));
    return isSafariUserAgent || isChrome;
};
exports.isWebkit = isWebkit;
